module.exports = __webpack_public_path__ + "img/tool_icon_3.e110f90.png";